import { asText, Content } from '@prismicio/client';

import { BlockQuote } from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

type WithQuoteProps = {
  slice: Content.RegionSliceWithQuote;
};

export const WithQuote = ({ slice }: WithQuoteProps) => {
  const { primary } = slice;
  const { quote, submitter } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <BlockQuote citation={asText(submitter)}>
      <RichText content={quote} variant="default" websiteUrl={WebsiteUrl} />
    </BlockQuote>
  );
};
